<template>
  <sign-page
    title-text="软件安装类型"
    :request="request"
    :column-list="columnList"
    :form-parms-add="formParmsAdd"
    :form-parms-update="formParmsUpdate"
    :need-data-file="true">
  </sign-page>
</template>

<script>
import {
  installTypeRequest as request
} from '@/api'

export default {
  computed: {
    formParmsAdd: {
      get () {
        let data = [{
          type: 'input',
          label: '名称',
          key: 'name',
          check: {
            required: true
          }
        },
        {
          type: 'select',
          label: '所需文件名称',
          key: 'filename',
          selectDatas: this.$store.getters.appFileNameList
        },
        {
          type: 'textarea',
          label: '安装方式',
          key: 'installInfo'
        },
        {
          type: 'textarea',
          label: '检查方式',
          key: 'checkInfo'
        },
        {
          type: 'textarea',
          label: '卸载方式',
          key: 'uninstallInfo'
        },
        {
          type: 'textarea',
          label: '默认配置',
          key: 'defaultConfig'
        }]
        return data
      }
    },
    formParmsUpdate: {
      get () {
        let data = []
        this.formParmsAdd.forEach((item) => {
          let newItem = {}
          for (let key in item) {
            newItem[key] = item[key]
          }
          data.push(newItem)
        })
        return data
      }
    },
    columnList: {
      get () {
        let data = []
        this.formParmsAdd.forEach((item) => {
          data.push({
            field: item.key,
            title: item.label
          })
        })
        return data
      }
    }
  },
  created () {
    this.$store.dispatch('loadAppFileNameList')
    // this.$store.dispatch('loadSysParamsConf')
  },
  methods: {
  },
  data () {
    return {
      request: request
    }
  }
}
</script>
